module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"select":"Выберите платёжный период","discountText":"Скидка применяется только в первый месяц оплаты тарифа","discount":"Скидка","discount2":"на первую оплату тарифа благодаря реферальной ссылке"}}')
  delete Component.options._Ctor
}
